import { PlayerModel } from '@toilet-paper-games/core';
import { makeAutoObservable, reaction } from 'mobx';
import { HosterUserModel } from './HosterUserModel';

export class HosterPlayerModelHandler {
  playerModel: PlayerModel;

  destructors: (() => void)[] = [];

  constructor(private user: HosterUserModel) {
    this.playerModel = PlayerModel.fromDto({ ...user.playerInfo, ready: false });

    this.setupReaction();

    makeAutoObservable(this, {}, { autoBind: true });
  }

  destroy() {
    for (const destructor of this.destructors) {
      destructor();
    }
  }

  // if userModel is updated, update playerModel
  setupReaction() {
    this.destructors.push(
      reaction(
        () => this.user.playerInfo,
        (data) => {
          // Note: If playerModel get new properties, add them here
          this.playerModel.active = data.active;
          this.playerModel.image = data.image;
          this.playerModel.isHost = data.isHost;
          this.playerModel.screenName = data.screenName;
          this.playerModel.subscription = data.subscription;
          this.playerModel.hasConnection = data.hasConnection;
        },
      ),
    );

    this.destructors.push(
      reaction(
        () => this.user.hasConnection,
        (active) => {
          if (!active) {
            this.playerModel.ready = false;
          }
        },
      ),
    );
  }
}
